// extracted by mini-css-extract-plugin
export default {"root":"BrandTrends_root__psEIt","header":"BrandTrends_header__MX1XD","body":"BrandTrends_body__bKOq6","chart-container":"BrandTrends_chart-container__ovV9+"};